import { getSessionStorage } from '@/shared/lib/storage';
import { isDebugEnabled } from '@/shared/lib/system';

/**
 * 契約期間タイプ。テナントの billing_period_type と整合する。
 * shared 層は entities 層への直接依存が FSD で禁じられているためここで再定義する。
 */
export type BillingPeriodType = 'monthly' | 'yearly';

/**
 * 契約期間タイプを解決する
 *
 * - 通常は API レスポンスの値（rawType）を返す
 * - デバッグ環境では `debug-billing-period-type-override` セッションストレージを優先する
 * - rawType が未取得（undefined）の場合は安全側に倒して 'monthly' を返す
 *
 * 既存の `useIsAdmin` における `debug-role-override` の取り扱いと同様のパターン。
 */
export const resolveBillingPeriodType = (
  rawType: BillingPeriodType | undefined,
): BillingPeriodType => {
  if (isDebugEnabled()) {
    const override = getSessionStorage('debug-billing-period-type-override');
    if (override === 'monthly' || override === 'yearly') {
      return override;
    }
  }
  return rawType ?? 'monthly';
};
